export default __webpack_public_path__ + "static/media/barisuc3.83ac1c05.jpg";